import { fetch, fetchTree } from '@/api/categories'
import Vue from 'vue'

export default {
  state: {
    data: [],
    pagination: {},
    tree:[],
  },

  mutations: {
    SET_CATEGORIES_TREE: (state, categories) => {

      //state.tree = categories


      Vue.set(state,'tree' ,categories);
    },

    SET_CATEGORIES: (state, categories) => {
      state.data = categories.data
      state.pagination = categories.pagination
    },
  },

  actions: {
    fetchCategories({ commit }, queryParams) {
      return new Promise((resolve, reject) => {
        fetch(queryParams)
          .then(({ data }) => {
            commit('SET_CATEGORIES', data)
            resolve(data)
          })
          .catch(e => reject(e))
      })
    },
  

  fetchCategoriesTree({ commit }) {

      return new Promise((resolve, reject) => {
        fetchTree()
          .then(({ data }) => {
            commit('SET_CATEGORIES_TREE', data)
            resolve(data)
          })
          .catch(e => reject(e))
      })
    }
  },

}
